import AuthService from '../services/auth.service';
import MemberAuthService from '../services/memberAuth.service';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess');
          return Promise.resolve(response.data);
        },
        error => {
          commit('registerFailure');
          return Promise.reject(error);
        }
      );
    },
    refreshToken({ commit }, accessToken) {
      commit('refreshToken', accessToken);
    },
    member_login({ commit }, user) {
      return AuthService.member_login(user).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    loginToken({ commit }, token) {
      return AuthService.loginToken(token).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);            
        }
      );
    },
    loginByPhoneAndPasscode({ commit }, user) {
      return AuthService.loginByPhoneAndPasscode(user).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    sendOneTimePasscode({ commit }, user) {
      return AuthService.sendOneTimePasscode(user).then(
        user => {
          console.log(commit);
          return Promise.resolve(user);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    sendResetToInitialPasscode({ commit }, user) {
      return AuthService.sendResetToInitialPasscode(user).then(
        user => {
          console.log(commit);
          return Promise.resolve(user);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    changePasscode({ commit }, user) {
      return AuthService.changePasscode(user).then(
        user => {
          console.log(commit);
          return Promise.resolve(user);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    sendOtp({ commit }, data) {
      return MemberAuthService.sendOtp(data).then(
        response => {
          commit('sendOtpSuccess');
          return Promise.resolve(response);
        },
        error => {
          commit('sendOtpFailure');
          return Promise.reject(error);
        }
      );
    },
    loginOtp({ commit }, user) {
      return MemberAuthService.loginOtp(user).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
    refreshToken(state, accessToken) {
      state.status.loggedIn = true;
      state.user = { ...state.user, accessToken: accessToken };
    },
    sendOtpSuccess(state) {
      state.status.loggedIn = false;
    },
    sendOtpFailure(state) {
      state.status.loggedIn = false;
    }
  }
};
